import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { BaseListComponent } from '../../organisms/base-list/base-list.component';
import { Colorset, colorsetTemplates } from '../../../models/colorset';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { MenuItem, MessageService, SharedModule } from 'primeng/api';
import { SidebarService } from '../../../services/menu/sidebar.service';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { DebugComponent } from '../../atoms/debug/debug.component';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../../organisms/mask/mask.component';
import { NgIf } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { TableCaptionComponent } from '../table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../table-list-actions/table-list-actions.component';
import { TableModule } from 'primeng/table';
import { ColorsetStore } from '../../../stores/colorset/colorset.state';
import { ColorsComponent } from '../../atoms/colors/colors.component';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  selector: 'app-colorset-administration',
  standalone: true,
  imports: [
    DebugComponent,
    HeaderComponent,
    MaskComponent,
    NgIf,
    RouterOutlet,
    SharedModule,
    SidebarModule,
    TableCaptionComponent,
    TableListActionsComponent,
    TableModule,
    ColorsComponent,
    RouterLink,
    AlertComponent,
  ],
  templateUrl: './colorset-administration.component.html',
  styleUrl: './colorset-administration.component.scss',
})
export class ColorsetAdministrationComponent
  extends BaseListComponent<Colorset>
  implements AfterViewInit
{
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-11',
    icon: 'fas fa-palette',
    headerText: 'Farbsets',
  };

  protected readonly colorsetTemplates = colorsetTemplates;
  readonly store = inject(ColorsetStore);
  readonly activeUserStore = inject(ActiveUserStore);
  override menuItems: MenuItem[] = [];
  override sidebarId = 'colorset-administration';

  constructor(
    protected sidebarService: SidebarService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }

  ngAfterViewInit() {
    this.sidebarService.setConfiguration(this.sidebarConfig);
  }
}
